<h2 class="mbottom-12">{{ 'commercialCommon.scaAuthentication.pleaseAuthenticateYourCreditCard' | transloco }}</h2>
<p class="mb-4">
  <transloco
    id="d7dddd65-e76f-4f32-9716-c3e023d56c65"
    key="commercialCommon.scaAuthentication.toEnsureSecurePayment"
    [params]="{ cardType: cardType | cardTypeDescription | async }"></transloco>
</p>
<yat-buttons
  [primaryButtonName]="'commercialCommon.scaAuthentication.continueWithAuthentication' | transloco"
  [secondaryButtonName]="('cancel' | commonWording | async) ?? ''"
  [verticalAlignment]="true"
  (primaryButtonClickMethod)="continue()"
  (secondaryButtonClickMethod)="cancel()"
  [matomoEventCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
  matomoEventClickPrimaryButtonAction="Continue_ScaAuthentication"
  matomoEventClickSecondaryButtonAction="Cancel_ScaAuthentication">
</yat-buttons>
